import { render, staticRenderFns } from "./Decorate.vue?vue&type=template&id=2ea3fc76&scoped=true&"
import script from "./Decorate.vue?vue&type=script&lang=js&"
export * from "./Decorate.vue?vue&type=script&lang=js&"
import style0 from "./Decorate.vue?vue&type=style&index=0&id=2ea3fc76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3fc76",
  null
  
)

export default component.exports